import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, CircularProgress,
  Box, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Chip,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const formatFechaHora = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

const HistorialProductoDialog = ({ open, onClose, productoId, productoNombre }) => {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !productoId) return;
    setLoading(true);
    setError("");
    axios.get(`/api/inventario-interno/productos/${productoId}/historial`)
      .then(({ data }) => setHistorial(data?.data || []))
      .catch((e) => setError(e?.response?.data?.message || "Error al cargar el historial."))
      .finally(() => setLoading(false));
  }, [open, productoId]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Historial — {productoNombre}</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 1.5 }}>{error}</Alert>}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={22} />
          </Box>
        ) : historial.length === 0 ? (
          <Alert severity="info">No tiene movimientos registrados.</Alert>
        ) : (
          <TableContainer>
            <Table size="small" sx={{ "& td, & th": { py: 0.4, px: 0.6, fontSize: "0.76rem" } }}>
              <TableHead>
                <TableRow>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Origen</TableCell>
                  <TableCell>Destino</TableCell>
                  <TableCell align="center">Cantidad</TableCell>
                  <TableCell align="center">Estado</TableCell>
                  <TableCell>Detalle</TableCell>
                  <TableCell>Usuario</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historial.map((r) => (
                  <TableRow key={r.id} hover>
                    <TableCell>{formatFechaHora(r.fecha_registro)}</TableCell>
                    <TableCell>{r.tipo}</TableCell>
                    <TableCell>{r.id_sucursal_origen}</TableCell>
                    <TableCell>{r.id_sucursal_destino}</TableCell>
                    <TableCell align="center">{r.cantidad}</TableCell>
                    <TableCell align="center">
                      <Chip
                        size="small" label={r.estado}
                        color={r.estado === "Pendiente" ? "warning" : "success"}
                        sx={{ height: 19, fontSize: "0.68rem" }}
                      />
                    </TableCell>
                    <TableCell sx={{ maxWidth: 260, whiteSpace: "pre-wrap" }}>{r.detalle || "-"}</TableCell>
                    <TableCell>{r.usuario}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default HistorialProductoDialog;
